import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("C:/Users/Nabil/Desktop/find_app/layouts/default.vue").then(m => m.default || m))
}